import React, { useEffect, useRef, useState } from 'react';
import auth from './auth';
import { useHistory } from "react-router-dom";
  
export const LogoutComponent = () => {
  
  const history = useHistory();

   const logout = () =>{
        auth.logout(() => {
          if (localStorage.getItem("isAndroidLogin")){
            localStorage.clear();
            android.logout();
          } else {
            localStorage.clear();
            history.push('/login');
          }
      });
    }

        return (
        <i className="fa fa-sign-out" onClick={logout}>
            <span className="font-size-smd bold p-l-5 font-family-default">
            Log Out
            </span>
        </i>

        );

  };